import type { ReactNode } from 'react';

interface CapabilityProps {
  /** Доступна ли способность. Гасить (🚫) следует ТОЛЬКО из-за освобождённого
   *  файла ('freed'). Ещё не отрендеренный файл ('absent') способность не
   *  отнимает — он просто не готов. */
  available: boolean;
  title: ReactNode;
  /** Пояснение-«почему»: и когда доступно, и когда нет. Кнопки не гасим молча. */
  why: ReactNode;
}

/** Одна строка блока «Что можно делать» (прототип §4). */
export function Capability({ available, title, why }: CapabilityProps) {
  return (
    <div className={available ? 'cap' : 'cap no'}>
      <span className="ic">{available ? '✅' : '🚫'}</span>
      <div>
        <b>{title}</b>
        <span>{why}</span>
      </div>
    </div>
  );
}

/** Контейнер блока способностей — вертикальный список <Capability />. */
export function CapabilityBlock({ children }: { children: ReactNode }) {
  return <div className="caps">{children}</div>;
}
